<p-menubar [model]="menuService.menuItems()">
    <ng-template #end>
        <!-- <img [src]="logoImg" width="50px" height="50px" class="mr-2" /> -->
        <img [src]="logoImgUrl" width="50px" height="50px" class="mr-2"/>
    </ng-template>
</p-menubar>